import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

export const initialState = {
  items: [],
  isFetching: false,
  error: null,
}

export const readRecurrentCharge = createAsyncActions('recurrentCharge/read')
export const createRecurrentCharge = createAsyncActions(
  'recurrentCharge/create'
)
export const activateRecurrentCharge = createAsyncActions(
  'recurrentCharge/activate'
)
export const acceptRecurrentCharge = createAsyncActions(
  'recurrentCharge/accept'
)
export const cancelRecurrentCharge = createAsyncActions(
  'recurrentCharge/cancel'
)
export const declineRecurrentCharge = createAsyncActions(
  'recurrentCharge/decline'
)

const recurrentChargesSlice = createSlice({
  name: 'recurrentCharge',
  initialState,
  reducers: {
    recurrentChargePollStart(state) {
      state.isFetching = true
    },
    recurrentChargePollStop(state) {
      state.isFetching = false
    },
    archiveRecurrentCharge(state, { payload }) {
      const itemId = payload?.json?.id || payload?.item?.id
      state.items = state.items.filter((item) => item.id !== itemId)
    },
  },

  extraReducers: ({ addCase }) => {
    addCase(acceptRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(acceptRecurrentCharge.fulfilled, (state) => {
      state.isFetching = false
    })

    addCase(acceptRecurrentCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(declineRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(declineRecurrentCharge.fulfilled, (state, { payload }) => {
      state.isFetching = payload?.continueLoading || false
    })

    addCase(declineRecurrentCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(cancelRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(cancelRecurrentCharge.fulfilled, (state, { payload }) => {
      const itemIndex = state.items.findIndex(
        (item) => item.id === payload.item.id
      )
      state.items[itemIndex] = payload.item
      state.isFetching = false
    })

    addCase(cancelRecurrentCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(activateRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(activateRecurrentCharge.fulfilled, (state, { payload }) => {
      const itemIndex = state.items.findIndex(
        (item) => item.id === payload?.item?.id
      )

      state.isFetching = false
      state.items[itemIndex] = payload.item
    })

    addCase(activateRecurrentCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(createRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(createRecurrentCharge.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items.push(payload?.item)
    })

    addCase(createRecurrentCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(readRecurrentCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(readRecurrentCharge.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items.push(payload?.item)
    })

    addCase(readRecurrentCharge.rejected, (state) => {
      state.isFetching = false
    })
  },
})

export const {
  recurrentChargePollStart,
  recurrentChargePollStop,
  archiveRecurrentCharge,
} = recurrentChargesSlice.actions
export const reducer = recurrentChargesSlice.reducer
